var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 833,
    height: 331,
    viewBox: "0 0 833 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25556 212.106L0 223.399V330.811H833V0.658005L823.744 0.178566C814.489 -0.300874 795.978 -1.25975 777.467 19.1904C758.956 39.6406 740.444 81.4999 721.933 107.161C703.422 132.823 684.911 142.286 666.4 146.652C647.889 151.018 629.378 150.287 610.867 136.287C592.356 122.288 573.844 95.0193 555.333 91.6122C536.822 88.205 518.311 108.659 499.8 105.845C481.289 103.031 462.778 76.9488 444.267 64.5569C425.756 52.165 407.244 53.4634 388.733 77.418C370.222 101.373 351.711 147.983 333.2 145.609C314.689 143.234 296.178 91.874 277.667 82.4918C259.156 73.1097 240.644 105.705 222.133 112.743C203.622 119.781 185.111 101.261 166.6 117.665C148.089 134.069 129.578 185.397 111.067 197.547C92.5556 209.697 74.0444 182.668 55.5333 180.447C37.0222 178.226 18.5111 200.812 9.25556 212.106Z",
    fill: "#2A2C30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineDark);
export default __webpack_public_path__ + "static/media/line-dark.736770d983f4469f7fbed59850ada276.svg";
export { ForwardRef as ReactComponent };